<div class="bannerImg">
  <div class="desktopScreen">
    <div class="d-flex justify-content-center mt-5 pt-3 mb-5"><img src="assets/img/svg/bankAccountLink.svg" alt="" style="width: 158px; height: 143px;"></div>
    <div class="mt-4 ms-4">
      <p class="labelSubHead">Avail</p>
      <h3 class="labelHead">Personal Finance Manager</h3>
      <p class="labelSubHead">and manage your money smartly.</p>

    </div>
    <div class="row">
      <div class="col-md-12 col-sm-12 col-lg-12 ms-4">

        <p class="labelSubHead my-4">Have complete banking details at one place!</p>
        <div class="d-flex align-items-center" class="heading">
          <div class="ps-3 py-2 errorMsg">Easily manage your money</div>
        </div>
        <div class="d-flex align-items-center" class="heading">
          <div class="ps-3 py-2 errorMsg">Connect your bank account</div>
        </div>
        <div class="d-flex align-items-center" class="heading">
          <div class="ps-3 py-2 errorMsg">Keep track of your income and expenses at one place</div>
        </div>


      </div>
      <div class="positionBottom">
        <div class="d-flex justify-content-center">
          <button class="btn mt-4 mx-4 linkCta d-flex justify-content-between" type="submit" [disabled]="showlinkExpireMsg" (click)="epbitlyFlow()">
            <div class=" " id="getOTP">Link your Bank Account</div>
            <div>
              <img src="assets/img/svg/Icon-feather-arrow-right.svg" alt="" class="arrow">
            </div>
          </button>
        </div>
        <div *ngIf="showlinkExpireMsg" class="d-flex justify-content-center errorText">Your link has Expired</div>
      </div>

    </div>
  </div>


</div>